<template>
    <page-section class="page-section--sm primary lighten-5">
        <template #tit>
            <h2 class="tit tit--lg text-center">
                더 나은 삶을 위한 유익하고 좋은 균, <br class="d-none d-lg-block" />
                그 출발점은 바로 <span class="primary--text">식물유래</span> 입니다.
            </h2>
        </template>

        <v-row>
            <v-col v-for="(item, index) in items" :key="index" cols="12" md="6" xl="4">
                <v-card tile flat class="item-card">
                    <v-img :src="item.icon" alt="" class="item-card__icon" />
                    <div>
                        <v-card-title>
                            <div v-html="item.title" class="tit tit--sm" />
                        </v-card-title>
                        <v-card-text>
                            <ul>
                                <li v-for="(child, index) in item.children" :key="index" class="txt txt--lg font-weight-medium line-height-15">
                                    <v-row class="row--sm">
                                        <v-col cols="auto">·</v-col>
                                        <v-col>{{ child }}</v-col>
                                    </v-row>
                                </li>
                            </ul>
                        </v-card-text>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" xl="4" class="d-none d-md-block">
                <v-card img="/images/about/plant-logo.png" tile flat class="item-card" />
            </v-col>
        </v-row>
    </page-section>
</template>

<script>
import PageSection from "../templates/page-section.vue";

export default {
    components: {
        PageSection,
    },
    data() {
        return {
            items: [
                {
                    title: "식물성유산균 연구 <br /><span class='primary--text'>20년 이상</span>",
                    icon: "/images/about/plant-1.png",
                    children: [
                        "특허 균주 보유",
                        "장내 환경 최적화",
                        "안정화 기술 축적",
                        //
                    ],
                },
                {
                    title: "<span class='primary--text'>GMP인증</span>",
                    icon: "/images/about/plant-2.png",
                    children: [
                        "우수 건강기능식품 제조 기준 충족",
                        "위생·품질관리 철저",
                        "안전성 확보",
                        //
                    ],
                },
                {
                    title: "유산균 생존률, 내산성 <br />내열성 <span class='primary--text'>검증완료</span>",
                    icon: "/images/about/plant-3.png",
                    children: [
                        "장 도달 생존율 확보",
                        "산성·고온 환경에 강함",
                        "장건강 유지 검증",
                        //
                    ],
                },
                {
                    title: "프로바이오틱스 <br />및 포스트바이오틱스 <br />제품 다수 보유",
                    icon: "/images/about/plant-4.png",
                    children: [
                        "맞춤형 유산균 솔루션",
                        "포스트바이오틱스 제조기술",
                        "제품 다양성 확보",
                        //
                    ],
                },
                {
                    title: "사람·동물·식물을 위한 <br /><span class='primary--text'>유익균 생태계 구축</span>",
                    icon: "/images/about/plant-5.png",
                    children: [
                        "인체 마이크로바이옴 설계",
                        "반려동물 전용 유산균",
                        "식물 생장 미생물 솔루션",
                        //
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.item-card {
    padding: 72px 16px 16px;
    height: 100%;
    display: flex;
    align-content: flex-end;
    flex-wrap: wrap;
    position: relative;
    max-width: 384px;
    margin: auto;
    &__icon {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 50px;
    }
    .v-card {
        &__title,
        &__text {
            padding: 0;
        }
        &__title {
            margin-bottom: 20px;
        }
    }
}
@media (min-width: 400px) {
    .item-card {
        padding: 40px;
        &__icon {
            position: absolute;
            top: 40px;
            right: 40px;
        }
    }
}
@media (min-width: 1200px) {
    .item-card {
        aspect-ratio: 1/1;
        &__icon {
            width: 70px;
        }
    }
}
</style>